module.exports = __webpack_public_path__ + "img/dis04.c1b5155d.svg";